/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Edittabadjust2Inputs */

const en_edittabadjust2 = /** @type {(inputs: Edittabadjust2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adjust`)
};

const de_edittabadjust2 = /** @type {(inputs: Edittabadjust2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anpassen`)
};

/**
* | output |
* | --- |
* | "Adjust" |
*
* @param {Edittabadjust2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const edittabadjust2 = /** @type {((inputs?: Edittabadjust2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Edittabadjust2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_edittabadjust2(inputs)
	return de_edittabadjust2(inputs)
});
export { edittabadjust2 as "editTabAdjust" }